let locales = {};

locales.id = "zh_CN";

/**
 * fields/messages for example $field("xxxx")/$msg("xxxx") or
 * $locale.FIELDS.xxxx/$locale.MESSAGES.xxxx
 */
let fields = {}, messages = {};
locales.FIELDS = fields;
locales.MESSAGES = messages;
messages["Currency"] = {
	"AUD": "澳大利亚元",
	"CAD": "加拿大元",
	"CHF": "瑞士法郎",
	"CNY": "人民币",
	"EUR": "欧元",
	"GBP": "英镑",
	"HKD": "港币",
	"JPY": "日元",
	"NZD": "新西兰元",
	"SEK": "瑞典克郎",
	"SGD": "新加坡元",
	"USD": "美元"
};
messages["idCard"] = {
	"00": "居民身份证",
	"01": "临时身份证",
	"03": "军人身份证",
	"04": "武警身份证",
	"05": "护照",
	"06": "港澳居民往来内地通行证/回乡证",
	"07": "台湾居民往来内地通行证",
	"08": "其他身份证明文件(个人)"
};

//交易状态
messages["YYY_JYZT"] = {
	"0": "交易成功",
	"1": "交易失败",
	"9": "待处理"
};

messages["PayBusiType"] = {
	'0': '电费',
	'1': '水费',
	'2': '燃气费',
	'3': '通讯费',
	'4': '有线电视费',
	'5': '加油卡充值',
	'6': '供暖费',
	'7': '物业费',
	'8': '其他'
};

export default function $field(key, fileds = 'messages') {
	return $locale[fileds][key];
}


// WEBPACK FOOTER //
// ./src/modules/service/$locale.js